export default __webpack_public_path__ + "static/media/mascots_love.c580a627.svg";